import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import SingleImg from '../../../components/singleImg';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        tagIndex: PropTypes.string,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content, tagIndex } = this.props;
        const { title = '', data = [] } = content;
        const { articleList = [] } = data;

        return (
            <section className={styles.topicModule} id={tagIndex}>
                <h2 className={styles.topicModule_title}>{title}</h2>
                <div className={styles.topicModule_box}>
                    {articleList.map((item, index) => <SingleImg content={item} key={index} />)}
                </div>
            </section>
        );
    }
}

export default errorBoundary(Banner);
